import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

type EditablePluginProps = {
  editable?: boolean;
};

/**
 * Plugin that updates the Lexical editor's editable state when the prop changes.
 * This is necessary because the initial config (which includes editable) is frozen
 * in a useRef and doesn't update when props change.
 */
export const EditablePlugin = ({ editable }: EditablePluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    // Default to true if not specified
    const isEditable = editable ?? true;
    editor.setEditable(isEditable);
  }, [editable, editor]);

  return null;
};
